
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  window.onload = function(event)  {
    var all_logout = document.querySelectorAll("a[href$='/account/logout']"); // Change selector as per you reqirement.
    for (var i = 0; i < all_logout.length; i++) {
      var al = all_logout[i];
      al.setAttribute("data-no-instant", "");
    }
  };
}(Flits));
